import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { trackById } from '../../../shared';
import {
  ECustomFieldDetailsView,
  ICustomFieldValue,
  ICustomFieldValueUI,
} from '../../interfaces';

@Component({
  selector: 'lum-custom-field-value-details',
  templateUrl: './custom-field-value-details.component.html',
  styleUrls: ['./custom-field-value-details.component.scss'],
})
export class CustomFieldValueDetailsComponent implements OnInit, OnChanges {
  @Input()
  view :'table' | 'list' = ECustomFieldDetailsView.LIST;

  @Input()
  customFieldValues :ICustomFieldValue[] = [];

  customFieldValuesUI :ICustomFieldValueUI[] = [];
  customFieldDetailsView = ECustomFieldDetailsView;

  trackById = trackById;

  constructor() {}

  ngOnInit() :void {
    this.initCustomFieldValuesUI();
  }

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes['customFieldValues']) {
      this.initCustomFieldValuesUI();
    }
  }

  private initCustomFieldValuesUI() :void {
    this.customFieldValuesUI = this.customFieldValues.map((customFieldValue) => {
      return {
        id: customFieldValue.id,
        label: customFieldValue.custom_field.label,
        type: customFieldValue.custom_field.type,
        value:
          customFieldValue.value_string ||
          customFieldValue.value_date ||
          customFieldValue.value_number,
      };
    });
  }
}
